import { HttpService } from 'services/HttpService';
import AuthService from 'services/AuthService';
import { API_URL, tenantConfig } from 'config';
import { httpRequestWrapper } from 'util/Request';
import { SearchResponse } from 'store/types/Search';

class SearchService {
  public static search(searchInstance: string, query: string): Promise<SearchResponse> {
    return new Promise<SearchResponse>((resolve: (data: SearchResponse) => void, reject: (error: string) => void) => {
      httpRequestWrapper<SearchResponse>(
        HttpService.get(`${API_URL}/search/${searchInstance}?luceneQuery=${query}`, {
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
        }),
        resolve,
        reject
      );
    });
  }
}
export default SearchService;
